import React from "react";
import FormV3InputField from "../../Widgets/FormsV3/FormFieldsV3/FormV3InputField";
import FormV3CheckboxField from "../../Widgets/FormsV3/FormFieldsV3/FormV3CheckboxField";
import FormV3RadioField from "../../Widgets/FormsV3/FormFieldsV3/FormV3RadioField";
import FormV3SelectField from "../../Widgets/FormsV3/FormFieldsV3/FormV3SelectField";
import FormV3DateField from "../../Widgets/FormsV3/FormFieldsV3/FormV3DateField";

export const SUPPORTED_INLINE_EDIT_TYPES = new Set([
   "UUID",
   "String",
   "Number",
   "Decimal",
   "Boolean",
   "Checkbox",
   "Radio",
   "Select",
   "MultiSelect",
   "LocalDate",
   "LocalDateTime",
]);

/**
 * Lightweight variant of renderFormField used for inline cell editing in TableComponent.
 * Does NOT import FormV3TableField or FormV3ListTable to avoid a circular dependency:
 *   TableComponent → renderFormField → FormV3TableField → TableController → TableComponent
 */
export const renderTableInlineField = (field, formGUID, loading, handleFieldValueChange, intl) => {
   if (field === null) return null;
   if (!field?.type) return <span>{intl.formatMessage({ id: "global.fieldTypeError" })}</span>;

   if (
      field.type === "UUID" ||
      field.type === "String" ||
      field.type === "Number" ||
      field.type === "Decimal"
   ) {
      return (
         <FormV3InputField
            field={field}
            formGUID={formGUID}
            type={field.type}
            loading={loading}
            decorators={field.decorators}
            onValueChange={handleFieldValueChange}
         />
      );
   }

   if (field.type === "Boolean" || field.type === "Checkbox") {
      return (
         <FormV3CheckboxField
            field={field}
            formGUID={formGUID}
            decorators={field.decorators}
            onValueChange={handleFieldValueChange}
            loading={loading}
            isQuestionnaire={false}
         />
      );
   }

   if (field.type === "Radio") {
      return (
         <FormV3RadioField
            field={field}
            formGUID={formGUID}
            onValueChange={handleFieldValueChange}
            loading={loading}
         />
      );
   }

   if (field.type === "Select" || field.type === "MultiSelect") {
      return (
         <FormV3SelectField
            field={field}
            formGUID={formGUID}
            decorators={field.decorators}
            isMulti={field.type === "MultiSelect"}
            isClearable={field.type === "Select"}
            onValueChange={handleFieldValueChange}
            loading={loading}
         />
      );
   }

   if (field.type === "LocalDate" || field.type === "LocalDateTime") {
      return (
         <FormV3DateField
            field={field}
            formGUID={formGUID}
            decorators={field.decorators}
            onValueChange={handleFieldValueChange}
            loading={loading}
         />
      );
   }

   return <span style={{ color: "red" }}>{`Not supported type: ${field.type}`}</span>;
};
